import SectionHeading from "components/text/SectionHeading";
import { Wrench, RefreshCw, Package } from "lucide-react";

export const WordpressSection = ({ wordpress }) => {
  return (
    <div className="rounded-lg border bg-card p-4 shadow-sm xl:col-span-2">
      <SectionHeading
        title="WordPress"
        subtitle="Understand your WordPress environment"
      />
      <div className="mb-3 flex items-center gap-2 text-sm font-medium">
        <Wrench className="h-4 w-4" /> WordPress, PHP, and plugin upgrades
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-md border p-3">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <RefreshCw className="h-4 w-4" /> Core
          </div>
          <div className="mt-1 text-lg font-medium">
            {wordpress?.wordpress_version}
          </div>
          <div className="text-xs text-muted-foreground">
            {/* {wordpress?.core.date} */}
          </div>
        </div>
        <div className="rounded-md border p-3">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Package className="h-4 w-4" /> PHP
          </div>
          <div className="mt-1 text-lg font-medium">
            {wordpress?.php_version}
          </div>
          <div className="text-xs text-muted-foreground">
            {/* {wordpress?.php.date} */}
          </div>
        </div>
      </div>
      <div className="rounded-md border p-3 mt-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Package className="h-4 w-4" /> {wordpress?.plugins?.length} Plugins
        </div>
        <ul className="mt-2 pr-2 space-y-1 text-sm max-h-[300px] overflow-y-auto">
          {wordpress?.plugins?.map((p: any) => (
            <li key={p.name} className="flex items-center justify-between">
              <span>{p.name}</span>
              <span className="text-xs text-muted-foreground">{p.version}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
